import React from 'react'
import styled from 'styled-components'
import { ArrowDropDown } from '@material-ui/icons'
import { svgIconStyle } from '../../../theme/Global/index'

export const TableControls = styled.div`
  margin: 25px auto;
  flex: 0 0 auto;
  flex-direction: row;
`

export const TableLabel = styled.p`
  font-family: "Open Sans";
  font-size: 17px;
  font-weight: 600;
  line-height: 13px;
  margin: 0;
`

export const CustomArrowDropDown = (
  <ArrowDropDown style={svgIconStyle({
    height: '24px',
    width: '24px'
  })}
  />
)
